// Approved recruitment sources allowlist (PT1-016).
// Add new sources via PR to this file. Anything not in this list is rejected
// by the signup endpoint per AC1.2.
export const APPROVED_SOURCE_OPTIONS = [
  { label: 'Organic', source: 'organic' },
  { label: 'Direct', source: 'direct' },
  { label: 'Referral', source: 'referral' },
  { label: 'Facebook', source: 'facebook' },
  { label: 'Instagram', source: 'instagram' },
  { label: 'Google', source: 'google' },
  { label: 'TikTok', source: 'tiktok' },
  { label: 'CMR house list', source: 'cmr-house-list' },
  { label: 'Brother list 2026 Q2', source: 'brother-list-2026q2' },
  { label: 'Omnibus DM_573', source: 'omnibus-dm573' },
  { label: 'Focus Group warm list', source: 'focus-group' },
  { label: 'Partner Digicel co-promo', source: 'partner-digicel-co-promo' },
  { label: 'Unknown', source: 'unknown' },
] as const;

export const APPROVED_SOURCES = APPROVED_SOURCE_OPTIONS.map((option) => option.source) as [
  (typeof APPROVED_SOURCE_OPTIONS)[number]['source'],
  ...(typeof APPROVED_SOURCE_OPTIONS)[number]['source'][],
];

export type ApprovedSource = (typeof APPROVED_SOURCES)[number];

// T&T parishes / regions for the signup form region dropdown (ADR-018).
export const TT_REGIONS = [
  'Diego Martin',
  'San Juan-Laventille',
  'Tunapuna-Piarco',
  'San Fernando',
  'Couva-Tabaquite-Talparo',
  'Princes Town',
  'Sangre Grande',
  'Mayaro-Rio Claro',
  'Penal-Debe',
  'Siparia',
  'Port of Spain',
  'Arima',
  'Chaguanas',
  'Point Fortin',
  'Tobago',
] as const;

export type TTRegion = (typeof TT_REGIONS)[number];

export const TT_ZONES = ['NW', 'NE', 'Central', 'SW', 'SE', 'Tobago'] as const;

export type TTZone = (typeof TT_ZONES)[number];

export const TT_REGION_TO_ZONE = {
  'Diego Martin': 'NW',
  'Port of Spain': 'NW',
  'San Juan-Laventille': 'NE',
  'Tunapuna-Piarco': 'NE',
  Arima: 'NE',
  'Sangre Grande': 'NE',
  'Couva-Tabaquite-Talparo': 'Central',
  Chaguanas: 'Central',
  Siparia: 'SW',
  'Penal-Debe': 'SW',
  'San Fernando': 'SW',
  'Point Fortin': 'SW',
  'Princes Town': 'SW',
  'Mayaro-Rio Claro': 'SE',
  Tobago: 'Tobago',
} as const satisfies Record<TTRegion, TTZone>;

export const TT_ZONE_MAP = TT_REGION_TO_ZONE;

export function getZoneForRegion(region: TTRegion): TTZone {
  return TT_REGION_TO_ZONE[region];
}

function buildTTZoneToRegions(): Record<TTZone, readonly TTRegion[]> {
  const zoneToRegions = Object.fromEntries(
    TT_ZONES.map((zone) => [zone, [] as TTRegion[]]),
  ) as Record<TTZone, TTRegion[]>;

  for (const [region, zone] of Object.entries(TT_REGION_TO_ZONE) as [TTRegion, TTZone][]) {
    zoneToRegions[zone].push(region);
  }

  return zoneToRegions;
}

export const TT_ZONE_TO_REGIONS = buildTTZoneToRegions();
